// extracted by mini-css-extract-plugin
export default {"yellow_btn":"button_yellow_btn__48m06","red_btn":"button_red_btn__AqMRT","outlined_btn":"button_outlined_btn__K8FEl","video_btn":"button_video_btn__R46Zx"};